import { useSearchParams } from "react-router";

const isUUID = (id: string) => {
  return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
    id,
  );
};

const parseResourceId = (id: string) => {
  return isUUID(id) ? id : parseInt(id, 10);
};

export const useSelectedResourceIdFromUrl = ({
  paramName,
}: {
  paramName: string;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Parse the URL search parameters.
  const resourceId = searchParams.get(paramName);

  const setSelectedResourceId = (id: number | string | null) => {
    if (id !== null) {
      setSearchParams((prev) => {
        const newSearchParams = new URLSearchParams(prev);
        newSearchParams.set(paramName, id.toString());
        return newSearchParams;
      });
    } else {
      setSearchParams((prev) => {
        const newSearchParams = new URLSearchParams(prev);
        newSearchParams.delete(paramName);
        return newSearchParams;
      });
    }
  };

  return {
    selectedResourceId: resourceId ? parseResourceId(resourceId) : null,
    setSelectedResourceId,
  };
};
